// app/assets/controllers/application/imask_controller.js
import { Controller } from '@hotwired/stimulus';
import IMask from 'imask';

export default class extends Controller {
  static values = { type: String };

  connect() {
    switch (this.typeValue) {
      case 'phone':
        this.mask = IMask(this.element, { mask: '+1 (000) 000-0000', lazy: true });
        break;
    }
  }

  disconnect() {
    this.mask?.destroy();
  }
}